export const getVouchers = async () => {
  const res = await fetch('https://dashboard.cohere.ph/api/get_vouchers.php', {
    credentials: 'include'
  });

  const data = await res.json();

  if (res.status !== 200) {
    throw new Error(data.error || 'Failed to load vouchers');
  }

  return data;
};
